import { Input } from "@/components/ui";
import type { ProveedorCompraInput } from "@/lib/types";

export function proveedorVacio(): ProveedorCompraInput {
  return {
    nombre: "",
    rfc: "",
    clave: null,
    calle: null,
    noInterior: null,
    noExterior: null,
    localidad: null,
    municipio: null,
    estado: null,
    pais: null,
    codigoPostal: null,
  };
}

interface Props {
  value: ProveedorCompraInput;
  onChange: (v: ProveedorCompraInput) => void;
}

/** Campos del proveedor del documento (nombre/RFC obligatorios · domicilio opcional). */
export function ProveedorFields({ value, onChange }: Props) {
  const upd = (patch: Partial<ProveedorCompraInput>) => onChange({ ...value, ...patch });
  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
      <Input label="Proveedor · nombre" required value={value.nombre} onChange={(e) => upd({ nombre: e.currentTarget.value })} />
      <Input label="Proveedor · RFC" required className="font-mono" value={value.rfc} onChange={(e) => upd({ rfc: e.currentTarget.value.toUpperCase() })} />
      <Input label="Clave SAP (opcional)" value={value.clave ?? ""} onChange={(e) => upd({ clave: e.currentTarget.value || null })} />
    </div>
  );
}
